import { Column, CreateDateColumn, Entity, JoinColumn, ManyToOne, PrimaryGeneratedColumn, UpdateDateColumn, VersionColumn } from "typeorm";
import { PurchaseOrderEntity } from "../../purchase-order/entities/purchase-order-entity";
import { GrnEntity } from "../../grn/entities/grn-entity";
import { Payments } from "./payments.entity";

@Entity('payment_uploads')
export class PaymentUploads{

    @PrimaryGeneratedColumn("increment",{name:'upload_id'})
    uploadId:number;
   
    @Column("varchar",{
      nullable: true,
      length:150,
      name:"file_name"
  })
  fileName:string;

  @Column("varchar",{
    nullable: true,
    length:150,
    name:"file_path"
  })
  filePath:string;

      @CreateDateColumn({
        name: "created_at",
        type:"datetime"
      })
      createdAt: Date;

      @Column("varchar", {
        nullable: true,
        name: "created_user"
    })
    createdUser: string | null;

    @UpdateDateColumn({
        name: "updated_at",
        type:'datetime'
    })
    updatedAt: Date;

    @Column("varchar", {
        nullable: true,
        name: "updated_user"
    })
    updatedUser: string | null;

    @VersionColumn({
        default:1,
        name: "version_flag"
    })
    versionFlag: number;

    @ManyToOne(type =>Payments,pay =>pay.uploadsInfo)
    @JoinColumn({name:'payment_id'})
    payments:Payments

}